module.exports = __webpack_public_path__ + "static/media/all-socio-turnos.e28c2e92.svg";